// removed by extract-text-webpack-plugin
module.exports = {"codeMessage":"codeMessage__vi6-w"};


//////////////////
// WEBPACK FOOTER
// ./src/components/fetchError/style.scss
// module id = 278
// module chunks = 0